/**
 * Use this file to import the icons you need from the untitled-ui library if an icon is not already in the list.
 */

import Activity from '@untitled-ui/icons-react/build/cjs/Activity';
import ActivityHeart from '@untitled-ui/icons-react/build/cjs/ActivityHeart';
import Airplay from '@untitled-ui/icons-react/build/cjs/Airplay';
import AlertCircle from '@untitled-ui/icons-react/build/cjs/AlertCircle';
import AlertTriangle from '@untitled-ui/icons-react/build/cjs/AlertTriangle';
import AlignCenter from '@untitled-ui/icons-react/build/cjs/AlignCenter';
import AlignLeft from '@untitled-ui/icons-react/build/cjs/AlignLeft';
import AnnotationAlert from '@untitled-ui/icons-react/build/cjs/AnnotationAlert';
import AnnotationCheck from '@untitled-ui/icons-react/build/cjs/AnnotationCheck';
import AnnotationDots from '@untitled-ui/icons-react/build/cjs/AnnotationDots';
import AnnotationInfo from '@untitled-ui/icons-react/build/cjs/AnnotationInfo';
import ArrowCircleBrokenRight from '@untitled-ui/icons-react/build/cjs/ArrowCircleBrokenRight';
import ArrowCircleRight from '@untitled-ui/icons-react/build/cjs/ArrowCircleRight';
import ArrowCircleUpRight from '@untitled-ui/icons-react/build/cjs/ArrowCircleUpRight';
import ArrowDown from '@untitled-ui/icons-react/build/cjs/ArrowDown';
import ArrowLeft from '@untitled-ui/icons-react/build/cjs/ArrowLeft';
import ArrowRight from '@untitled-ui/icons-react/build/cjs/ArrowRight';
import ArrowUp from '@untitled-ui/icons-react/build/cjs/ArrowUp';
import ArrowUpRight from '@untitled-ui/icons-react/build/cjs/ArrowUpRight';
import Atom01 from '@untitled-ui/icons-react/build/cjs/Atom01';
import Atom02 from '@untitled-ui/icons-react/build/cjs/Atom02';
import Award03 from '@untitled-ui/icons-react/build/cjs/Award03';
import Bank from '@untitled-ui/icons-react/build/cjs/Bank';
import BankNote01 from '@untitled-ui/icons-react/build/cjs/BankNote01';
import BarChartSquare02 from '@untitled-ui/icons-react/build/cjs/BarChartSquare02';
import BellRinging01 from '@untitled-ui/icons-react/build/cjs/BellRinging01';
import Bold01 from '@untitled-ui/icons-react/build/cjs/Bold01';
import Bookmark from '@untitled-ui/icons-react/build/cjs/Bookmark';
import BookmarkAdd from '@untitled-ui/icons-react/build/cjs/BookmarkAdd';
import BookmarkCheck from '@untitled-ui/icons-react/build/cjs/BookmarkCheck';
import BookOpen01 from '@untitled-ui/icons-react/build/cjs/BookOpen01';
import BookOpen02 from '@untitled-ui/icons-react/build/cjs/BookOpen02';
import Briefcase01 from '@untitled-ui/icons-react/build/cjs/Briefcase01';
import Briefcase02 from '@untitled-ui/icons-react/build/cjs/Briefcase02';
import Brush01 from '@untitled-ui/icons-react/build/cjs/Brush01';
import Building01 from '@untitled-ui/icons-react/build/cjs/Building01';
import Building06 from '@untitled-ui/icons-react/build/cjs/Building06';
import Building07 from '@untitled-ui/icons-react/build/cjs/Building07';
import Building08 from '@untitled-ui/icons-react/build/cjs/Building08';
import Calculator from '@untitled-ui/icons-react/build/cjs/Calculator';
import Calendar from '@untitled-ui/icons-react/build/cjs/Calendar';
import CalendarCheck01 from '@untitled-ui/icons-react/build/cjs/CalendarCheck01';
import CalendarDate from '@untitled-ui/icons-react/build/cjs/CalendarDate';
import CalendarPlus01 from '@untitled-ui/icons-react/build/cjs/CalendarPlus01';
import Camera01 from '@untitled-ui/icons-react/build/cjs/Camera01';
import Certificate01 from '@untitled-ui/icons-react/build/cjs/Certificate01';
import Certificate02 from '@untitled-ui/icons-react/build/cjs/Certificate02';
import ChartBreakoutCircle from '@untitled-ui/icons-react/build/cjs/ChartBreakoutCircle';
import Check from '@untitled-ui/icons-react/build/cjs/Check';
import CheckCircle from '@untitled-ui/icons-react/build/cjs/CheckCircle';
import CheckCircleBroken from '@untitled-ui/icons-react/build/cjs/CheckCircleBroken';
import CheckDone01 from '@untitled-ui/icons-react/build/cjs/CheckDone01';
import CheckSquareBroken from '@untitled-ui/icons-react/build/cjs/CheckSquareBroken';
import CheckVerified03 from '@untitled-ui/icons-react/build/cjs/CheckVerified03';
import ChevronDown from '@untitled-ui/icons-react/build/cjs/ChevronDown';
import ChevronLeft from '@untitled-ui/icons-react/build/cjs/ChevronLeft';
import ChevronLeftDouble from '@untitled-ui/icons-react/build/cjs/ChevronLeftDouble';
import ChevronRight from '@untitled-ui/icons-react/build/cjs/ChevronRight';
import ChevronSelectorVertical from '@untitled-ui/icons-react/build/cjs/ChevronSelectorVertical';
import ChevronUp from '@untitled-ui/icons-react/build/cjs/ChevronUp';
import Circle from '@untitled-ui/icons-react/build/cjs/Circle';
import Clipboard from '@untitled-ui/icons-react/build/cjs/Clipboard';
import ClipboardCheck from '@untitled-ui/icons-react/build/cjs/ClipboardCheck';
import ClipboardPlus from '@untitled-ui/icons-react/build/cjs/ClipboardPlus';
import Clock from '@untitled-ui/icons-react/build/cjs/Clock';
import ClockFastForward from '@untitled-ui/icons-react/build/cjs/ClockFastForward';
import CoinsStacked01 from '@untitled-ui/icons-react/build/cjs/CoinsStacked01';
import CoinsStacked02 from '@untitled-ui/icons-react/build/cjs/CoinsStacked02';
import Colors from '@untitled-ui/icons-react/build/cjs/Colors';
import Compass01 from '@untitled-ui/icons-react/build/cjs/Compass01';
import Compass03 from '@untitled-ui/icons-react/build/cjs/Compass03';
import Copy01 from '@untitled-ui/icons-react/build/cjs/Copy01';
import Copy02 from '@untitled-ui/icons-react/build/cjs/Copy02';
import Copy04 from '@untitled-ui/icons-react/build/cjs/Copy04';
import CpuChip01 from '@untitled-ui/icons-react/build/cjs/CpuChip01';
import CreditCardSearch from '@untitled-ui/icons-react/build/cjs/CreditCardSearch';
import CurrencyDollar from '@untitled-ui/icons-react/build/cjs/CurrencyDollar';
import CurrencyDollarCircle from '@untitled-ui/icons-react/build/cjs/CurrencyDollarCircle';
import CursorClick01 from '@untitled-ui/icons-react/build/cjs/CursorClick01';
import Data from '@untitled-ui/icons-react/build/cjs/Data';
import Dataflow01 from '@untitled-ui/icons-react/build/cjs/Dataflow01';
import Dataflow03 from '@untitled-ui/icons-react/build/cjs/Dataflow03';
import Dotpoints01 from '@untitled-ui/icons-react/build/cjs/Dotpoints01';
import DotPoints02 from '@untitled-ui/icons-react/build/cjs/Dotpoints02';
import DotsHorizontal from '@untitled-ui/icons-react/build/cjs/DotsHorizontal';
import DotsVertical from '@untitled-ui/icons-react/build/cjs/DotsVertical';
import Download01 from '@untitled-ui/icons-react/build/cjs/Download01';
import DownloadCloud01 from '@untitled-ui/icons-react/build/cjs/DownloadCloud01';
import Edit01 from '@untitled-ui/icons-react/build/cjs/Edit01';
import Edit02 from '@untitled-ui/icons-react/build/cjs/Edit02';
import Edit04 from '@untitled-ui/icons-react/build/cjs/Edit04';
import Edit05 from '@untitled-ui/icons-react/build/cjs/Edit05';
import Eye from '@untitled-ui/icons-react/build/cjs/Eye';
import EyeOff from '@untitled-ui/icons-react/build/cjs/EyeOff';
import FaceContent from '@untitled-ui/icons-react/build/cjs/FaceContent';
import File01 from '@untitled-ui/icons-react/build/cjs/File01';
import File02 from '@untitled-ui/icons-react/build/cjs/File02';
import File06 from '@untitled-ui/icons-react/build/cjs/File06';
import FileAttachment02 from '@untitled-ui/icons-react/build/cjs/FileAttachment02';
import FileShield02 from '@untitled-ui/icons-react/build/cjs/FileShield02';
import Film03 from '@untitled-ui/icons-react/build/cjs/Film03';
import FilterFunnel01 from '@untitled-ui/icons-react/build/cjs/FilterFunnel01';
import FilterLines from '@untitled-ui/icons-react/build/cjs/FilterLines';
import Flag01 from '@untitled-ui/icons-react/build/cjs/Flag01';
import Flag02 from '@untitled-ui/icons-react/build/cjs/Flag02';
import Flag04 from '@untitled-ui/icons-react/build/cjs/Flag04';
import Flag05 from '@untitled-ui/icons-react/build/cjs/Flag05';
import GamingPad02 from '@untitled-ui/icons-react/build/cjs/GamingPad02';
import GitPullRequest from '@untitled-ui/icons-react/build/cjs/GitPullRequest';
import Glasses02 from '@untitled-ui/icons-react/build/cjs/Glasses02';
import Globe01 from '@untitled-ui/icons-react/build/cjs/Globe01';
import Globe05 from '@untitled-ui/icons-react/build/cjs/Globe05';
import GraduationHat01 from '@untitled-ui/icons-react/build/cjs/GraduationHat01';
import GraduationHat02 from '@untitled-ui/icons-react/build/cjs/GraduationHat02';
import GridDotsBlank from '@untitled-ui/icons-react/build/cjs/GridDotsBlank';
import GridDotsHorizontalCenter from '@untitled-ui/icons-react/build/cjs/GridDotsHorizontalCenter';
import GridDotsLeft from '@untitled-ui/icons-react/build/cjs/GridDotsLeft';
import GridDotsOuter from '@untitled-ui/icons-react/build/cjs/GridDotsOuter';
import GridDotsTop from '@untitled-ui/icons-react/build/cjs/GridDotsTop';
import GridDotsVerticalCenter from '@untitled-ui/icons-react/build/cjs/GridDotsVerticalCenter';
import Hand from '@untitled-ui/icons-react/build/cjs/Hand';
import Hash01 from '@untitled-ui/icons-react/build/cjs/Hash01';
import Hash02 from '@untitled-ui/icons-react/build/cjs/Hash02';
import Heading01 from '@untitled-ui/icons-react/build/cjs/Heading01';
import Heart from '@untitled-ui/icons-react/build/cjs/Heart';
import HelpCircle from '@untitled-ui/icons-react/build/cjs/HelpCircle';
import Home03 from '@untitled-ui/icons-react/build/cjs/Home03';
import HomeLine from '@untitled-ui/icons-react/build/cjs/HomeLine';
import HomeSmile from '@untitled-ui/icons-react/build/cjs/HomeSmile';
import Hurricane01 from '@untitled-ui/icons-react/build/cjs/Hurricane01';
import Image01 from '@untitled-ui/icons-react/build/cjs/Image01';
import ImageUserUp from '@untitled-ui/icons-react/build/cjs/ImageUserUp';
import InfoCircle from '@untitled-ui/icons-react/build/cjs/InfoCircle';
import Italic01 from '@untitled-ui/icons-react/build/cjs/Italic01';
import LayerSingle from '@untitled-ui/icons-react/build/cjs/LayerSingle';
import LayersThree01 from '@untitled-ui/icons-react/build/cjs/LayersThree01';
import LayersTwo01 from '@untitled-ui/icons-react/build/cjs/LayersTwo01';
import LeftIndent01 from '@untitled-ui/icons-react/build/cjs/LeftIndent01';
import Lightbulb05 from '@untitled-ui/icons-react/build/cjs/Lightbulb05';
import Link01 from '@untitled-ui/icons-react/build/cjs/Link01';
import LinkExternal01 from '@untitled-ui/icons-react/build/cjs/LinkExternal01';
import List from '@untitled-ui/icons-react/build/cjs/List';
import Lock01 from '@untitled-ui/icons-react/build/cjs/Lock01';
import LockKeyholeSquare from '@untitled-ui/icons-react/build/cjs/LockKeyholeSquare';
import LockUnlocked01 from '@untitled-ui/icons-react/build/cjs/LockUnlocked01';
import LogIn01 from '@untitled-ui/icons-react/build/cjs/LogIn01';
import LogIn03 from '@untitled-ui/icons-react/build/cjs/LogIn03';
import LogOut01 from '@untitled-ui/icons-react/build/cjs/LogOut01';
import Luggage02 from '@untitled-ui/icons-react/build/cjs/Luggage02';
import Mail01 from '@untitled-ui/icons-react/build/cjs/Mail01';
import Mail05 from '@untitled-ui/icons-react/build/cjs/Mail05';
import Map01 from '@untitled-ui/icons-react/build/cjs/Map01';
import MarkerPin01 from '@untitled-ui/icons-react/build/cjs/MarkerPin01';
import MarkerPin05 from '@untitled-ui/icons-react/build/cjs/MarkerPin05';
import Maximize01 from '@untitled-ui/icons-react/build/cjs/Maximize01';
import MedicalSquare from '@untitled-ui/icons-react/build/cjs/MedicalSquare';
import Menu01 from '@untitled-ui/icons-react/build/cjs/Menu01';
import Menu02 from '@untitled-ui/icons-react/build/cjs/Menu02';
import MessageChatCircle from '@untitled-ui/icons-react/build/cjs/MessageChatCircle';
import MessageSquare02 from '@untitled-ui/icons-react/build/cjs/MessageSquare02';
import Microphone01 from '@untitled-ui/icons-react/build/cjs/Microphone01';
import Minus from '@untitled-ui/icons-react/build/cjs/Minus';
import MinusCircle from '@untitled-ui/icons-react/build/cjs/MinusCircle';
import MoonStar from '@untitled-ui/icons-react/build/cjs/MoonStar';
import Palette from '@untitled-ui/icons-react/build/cjs/Palette';
import Paperclip from '@untitled-ui/icons-react/build/cjs/Paperclip';
import Pencil01 from '@untitled-ui/icons-react/build/cjs/Pencil01';
import Phone from '@untitled-ui/icons-react/build/cjs/Phone';
import Phone01 from '@untitled-ui/icons-react/build/cjs/Phone01';
import PhoneCall01 from '@untitled-ui/icons-react/build/cjs/PhoneCall01';
import PieChart02 from '@untitled-ui/icons-react/build/cjs/PieChart02';
import PiggyBank01 from '@untitled-ui/icons-react/build/cjs/PiggyBank01';
import PiggyBank02 from '@untitled-ui/icons-react/build/cjs/PiggyBank02';
import Plane from '@untitled-ui/icons-react/build/cjs/Plane';
import PlayCircle from '@untitled-ui/icons-react/build/cjs/PlayCircle';
import Plus from '@untitled-ui/icons-react/build/cjs/Plus';
import PlusCircle from '@untitled-ui/icons-react/build/cjs/PlusCircle';
import PlusSquare from '@untitled-ui/icons-react/build/cjs/PlusSquare';
import PuzzlePiece01 from '@untitled-ui/icons-react/build/cjs/PuzzlePiece01';
import RefreshCcw01 from '@untitled-ui/icons-react/build/cjs/RefreshCcw01';
import RefreshCcw03 from '@untitled-ui/icons-react/build/cjs/RefreshCcw03';
import RefreshCcw05 from '@untitled-ui/icons-react/build/cjs/RefreshCcw05';
import ReverseRight from '@untitled-ui/icons-react/build/cjs/ReverseRight';
import RightIndent01 from '@untitled-ui/icons-react/build/cjs/RightIndent01';
import Rocket02 from '@untitled-ui/icons-react/build/cjs/Rocket02';
import Route from '@untitled-ui/icons-react/build/cjs/Route';
import Scales01 from '@untitled-ui/icons-react/build/cjs/Scales01';
import SearchLg from '@untitled-ui/icons-react/build/cjs/SearchLg';
import SearchMd from '@untitled-ui/icons-react/build/cjs/SearchMd';
import Send01 from '@untitled-ui/icons-react/build/cjs/Send01';
import Server06 from '@untitled-ui/icons-react/build/cjs/Server06';
import Settings01 from '@untitled-ui/icons-react/build/cjs/Settings01';
import Share01 from '@untitled-ui/icons-react/build/cjs/Share01';
import Share04 from '@untitled-ui/icons-react/build/cjs/Share04';
import Share06 from '@untitled-ui/icons-react/build/cjs/Share06';
import Shield01 from '@untitled-ui/icons-react/build/cjs/Shield01';
import ShieldDollar from '@untitled-ui/icons-react/build/cjs/ShieldDollar';
import Shuffle01 from '@untitled-ui/icons-react/build/cjs/Shuffle01';
import SlashCircle01 from '@untitled-ui/icons-react/build/cjs/SlashCircle01';
import Speedometer02 from '@untitled-ui/icons-react/build/cjs/Speedometer02';
import Speedometer03 from '@untitled-ui/icons-react/build/cjs/Speedometer03';
import Speedometer04 from '@untitled-ui/icons-react/build/cjs/Speedometer04';
import Square from '@untitled-ui/icons-react/build/cjs/Square';
import Stand from '@untitled-ui/icons-react/build/cjs/Stand';
import Stars01 from '@untitled-ui/icons-react/build/cjs/Stars01';
import Stars03 from '@untitled-ui/icons-react/build/cjs/Stars03';
import StickerCircle from '@untitled-ui/icons-react/build/cjs/StickerCircle';
import SunSetting02 from '@untitled-ui/icons-react/build/cjs/SunSetting02';
import SwitchHorizontal01 from '@untitled-ui/icons-react/build/cjs/SwitchHorizontal01';
import SwitchVertical01 from '@untitled-ui/icons-react/build/cjs/SwitchVertical01';
import Tag01 from '@untitled-ui/icons-react/build/cjs/Tag01';
import Target03 from '@untitled-ui/icons-react/build/cjs/Target03';
import Target04 from '@untitled-ui/icons-react/build/cjs/Target04';
import Target05 from '@untitled-ui/icons-react/build/cjs/Target05';
import Telescope from '@untitled-ui/icons-react/build/cjs/Telescope';
import ThumbsDown from '@untitled-ui/icons-react/build/cjs/ThumbsDown';
import ThumbsUp from '@untitled-ui/icons-react/build/cjs/ThumbsUp';
import Tool01 from '@untitled-ui/icons-react/build/cjs/Tool01';
import Tool02 from '@untitled-ui/icons-react/build/cjs/Tool02';
import Translate01 from '@untitled-ui/icons-react/build/cjs/Translate01';
import Trash01 from '@untitled-ui/icons-react/build/cjs/Trash01';
import TrendDown01 from '@untitled-ui/icons-react/build/cjs/TrendDown01';
import TrendDown02 from '@untitled-ui/icons-react/build/cjs/TrendDown02';
import TrendUp01 from '@untitled-ui/icons-react/build/cjs/TrendUp01';
import TrendUp02 from '@untitled-ui/icons-react/build/cjs/TrendUp02';
import Trophy01 from '@untitled-ui/icons-react/build/cjs/Trophy01';
import Underline01 from '@untitled-ui/icons-react/build/cjs/Underline01';
import UploadCloud02 from '@untitled-ui/icons-react/build/cjs/UploadCloud02';
import User01 from '@untitled-ui/icons-react/build/cjs/User01';
import User02 from '@untitled-ui/icons-react/build/cjs/User02';
import User03 from '@untitled-ui/icons-react/build/cjs/User03';
import UserCheck02 from '@untitled-ui/icons-react/build/cjs/UserCheck02';
import UserCircle from '@untitled-ui/icons-react/build/cjs/UserCircle';
import UserEdit from '@untitled-ui/icons-react/build/cjs/UserEdit';
import Users01 from '@untitled-ui/icons-react/build/cjs/Users01';
import Users02 from '@untitled-ui/icons-react/build/cjs/Users02';
import UserSquare from '@untitled-ui/icons-react/build/cjs/UserSquare';
import UserUp02 from '@untitled-ui/icons-react/build/cjs/UserUp02';
import VideoRecorder from '@untitled-ui/icons-react/build/cjs/VideoRecorder';
import VolumeMin from '@untitled-ui/icons-react/build/cjs/VolumeMin';
import Webcam01 from '@untitled-ui/icons-react/build/cjs/Webcam01';
import XClose from '@untitled-ui/icons-react/build/cjs/XClose';
import Youtube from '@untitled-ui/icons-react/build/cjs/Youtube';
import Zap from '@untitled-ui/icons-react/build/cjs/Zap';

export const UNTITLED_UI_ICONS = {
  Activity,
  ActivityHeart,
  Airplay,
  AlignCenter,
  AlignLeft,
  AlertCircle,
  AlertTriangle,
  AnnotationAlert,
  AnnotationCheck,
  AnnotationDots,
  AnnotationInfo,
  ArrowCircleBrokenRight,
  ArrowCircleRight,
  ArrowCircleUpRight,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  ArrowUp,
  Atom01,
  Atom02,
  Award03,
  Bank,
  BankNote01,
  BarChartSquare02,
  BellRinging01,
  Bold01,
  Bookmark,
  BookmarkAdd,
  BookmarkCheck,
  BookOpen01,
  BookOpen02,
  Briefcase01,
  Briefcase02,
  Brush01,
  Building01,
  Building06,
  Building07,
  Building08,
  Calculator,
  Calendar,
  CalendarCheck01,
  CalendarDate,
  CalendarPlus01,
  Camera01,
  Certificate01,
  Certificate02,
  ChartBreakoutCircle,
  Check,
  CheckCircle,
  CheckCircleBroken,
  CheckDone01,
  CheckVerified03,
  CheckSquareBroken,
  ChevronDown,
  ChevronLeft,
  ChevronLeftDouble,
  ChevronRight,
  ChevronSelectorVertical,
  ChevronUp,
  Circle,
  Clipboard,
  ClipboardCheck,
  ClipboardPlus,
  Clock,
  ClockFastForward,
  CoinsStacked01,
  CoinsStacked02,
  Colors,
  Compass01,
  Compass03,
  Copy01,
  Copy02,
  Copy04,
  CpuChip01,
  CursorClick01,
  CreditCardSearch,
  CurrencyDollar,
  CurrencyDollarCircle,
  Data,
  Dataflow01,
  Dataflow03,
  DotsHorizontal,
  DotsVertical,
  DotPoints02,
  Dotpoints01,
  Download01,
  DownloadCloud01,
  Edit01,
  Edit02,
  Edit04,
  Edit05,
  Eye,
  EyeOff,
  FaceContent,
  File01,
  File02,
  File06,
  FileAttachment02,
  FileShield02,
  Film03,
  FilterLines,
  FilterFunnel01,
  Flag01,
  Flag02,
  Flag04,
  Flag05,
  GitPullRequest,
  Glasses02,
  Globe01,
  Globe05,
  GamingPad02,
  GraduationHat01,
  GraduationHat02,
  GridDotsBlank,
  GridDotsHorizontalCenter,
  GridDotsLeft,
  GridDotsOuter,
  GridDotsTop,
  GridDotsVerticalCenter,
  Hand,
  Hash01,
  Hash02,
  Heading01,
  Heart,
  HelpCircle,
  HomeSmile,
  Home03,
  HomeLine,
  Hurricane01,
  Image01,
  ImageUserUp,
  InfoCircle,
  Italic01,
  LayerSingle,
  LayersThree01,
  LayersTwo01,
  LeftIndent01,
  Lightbulb05,
  Link01,
  LinkExternal01,
  List,
  Lock01,
  LockKeyholeSquare,
  LockUnlocked01,
  LogIn01,
  LogOut01,
  Luggage02,
  Mail01,
  Mail05,
  Map01,
  MarkerPin01,
  MarkerPin05,
  MedicalSquare,
  Menu01,
  Menu02,
  MessageChatCircle,
  MessageSquare02,
  Microphone01,
  Minus,
  MinusCircle,
  MoonStar,
  Palette,
  Paperclip,
  Pencil01,
  Phone,
  Phone01,
  PhoneCall01,
  PiggyBank01,
  PiggyBank02,
  Plane,
  PlayCircle,
  Plus,
  PlusCircle,
  PlusSquare,
  PieChart02,
  PuzzlePiece01,
  RefreshCcw01,
  RefreshCcw05,
  RefreshCcw03,
  ReverseRight,
  RightIndent01,
  Rocket02,
  Route,
  Scales01,
  SearchMd,
  SearchLg,
  Send01,
  Server06,
  Settings01,
  Share01,
  Share04,
  Share06,
  Shield01,
  ShieldDollar,
  SlashCircle01,
  Speedometer02,
  Speedometer03,
  Speedometer04,
  Square,
  Stand,
  Stars01,
  Stars03,
  StickerCircle,
  SunSetting02,
  SwitchHorizontal01,
  SwitchVertical01,
  Tag01,
  Target03,
  Target04,
  Target05,
  Telescope,
  ThumbsDown,
  ThumbsUp,
  Tool01,
  Tool02,
  Translate01,
  Trash01,
  TrendDown01,
  TrendDown02,
  TrendUp01,
  TrendUp02,
  Trophy01,
  Underline01,
  UploadCloud02,
  User01,
  User02,
  User03,
  UserCheck02,
  UserCircle,
  UserEdit,
  UserSquare,
  UserUp02,
  Users01,
  Users02,
  VideoRecorder,
  VolumeMin,
  Webcam01,
  Youtube,
  XClose,
  Zap,
  Shuffle01,
  LogIn03,
  Maximize01,
} as const;
